__turbopack_context__.v({
  "blur": "PrimaryHeaderNav-module__PRs2BW__blur",
  "colLeft": "PrimaryHeaderNav-module__PRs2BW__colLeft",
  "colRight": "PrimaryHeaderNav-module__PRs2BW__colRight",
  "does-not-exist": "PrimaryHeaderNav-module__PRs2BW__does-not-exist",
  "evIcon": "PrimaryHeaderNav-module__PRs2BW__evIcon",
  "header": "PrimaryHeaderNav-module__PRs2BW__header",
  "headerInner": "PrimaryHeaderNav-module__PRs2BW__headerInner",
  "js-has-pseudo": "PrimaryHeaderNav-module__PRs2BW__js-has-pseudo",
  "logo": "PrimaryHeaderNav-module__PRs2BW__logo",
  "removeTransparency": "PrimaryHeaderNav-module__PRs2BW__removeTransparency",
  "wrapper": "PrimaryHeaderNav-module__PRs2BW__wrapper",
});
